import { createReducer } from '@reduxjs/toolkit';
import { resetPaymentErrors, setIsPaymentNotAllowed, setIsTerminalPaymentIsProcessing, setIsWentWrong, setPaymentErrorCondition, setShouldRetry, setTerminalResult, } from './actions';
const initialState = {
    isTerminalProcessing: false,
    isPaymentNotAllowed: false,
    shouldRetry: false,
    isWentWrong: false,
    errorPaymentCondition: '',
    terminalResult: {
        additionalResponse: '',
        result: '',
        serviceID: '',
        transactionID: '',
    },
};
export const reducer = createReducer(initialState, (builder) => {
    builder
        .addCase(setIsTerminalPaymentIsProcessing, (state, { payload }) => ({
        ...state,
        isTerminalProcessing: payload,
    }))
        .addCase(setIsPaymentNotAllowed, (state, { payload }) => ({
        ...state,
        isPaymentNotAllowed: payload,
    }))
        .addCase(setPaymentErrorCondition, (state, { payload }) => ({
        ...state,
        errorPaymentCondition: payload,
    }))
        .addCase(setTerminalResult, (state, { payload }) => ({
        ...state,
        terminalResult: {
            ...payload,
        },
    }))
        .addCase(setShouldRetry, (state, { payload }) => ({
        ...state,
        shouldRetry: payload,
    }))
        .addCase(setIsWentWrong, (state, { payload }) => ({
        ...state,
        isWentWrong: payload,
    }))
        .addCase(resetPaymentErrors, () => initialState);
});
